import React, { useState, useEffect } from 'react';
import './SellerPortal.css';
import SellerAuth from './SellerAuth';
import { clearAuth, walletAPI } from './SellerApi.js';

// Clean Import
import AddProducts from './AddProducts';

import SellerDashboard from './SellerDashboard'; 
import ManagePricing from './ManagePricing'; 
import SellerOrders from './SellerOrders';
import SellerReturns from './SellerReturns';
import SellerWallet from './SellerWallet';
import SellerDeals from './SellerDeals';
import SellerProfile from './SellerProfile';
import SellerPolicies from './SellerPolicies';
import SellerNotifications from './SellerNotifications';





const NAV = [
  { group:'Overview',   items:[{ id:'dashboard',    label:'Dashboard',    icon:'◈' }] },
  { group:'Products',   items:[{ id:'add-product',  label:'Add Product',  icon:'⊕' }, { id:'pricing',      label:'Manage Pricing', icon:'◎' }] },
  { group:'Commerce',   items:[{ id:'orders',       label:'Orders',       icon:'⊞' }, { id:'returns',      label:'Returns',        icon:'↩' }, { id:'deals',        label:'Deals',          icon:'✦' }] },
  { group:'Earnings',   items:[{ id:'wallet',       label:'Wallet',       icon:'◐' }] },
  { group:'Account',    items:[{ id:'profile',      label:'Profile & Address', icon:'▣' }, { id:'policies',    label:'Terms & Policies', icon:'✎' }, { id:'notifications',label:'Notifications',    icon:'◉' }] },
];

const PAGE_TITLES = { dashboard:'Dashboard', 'add-product':'Add New Product', pricing:'Manage Pricing', orders:'My Orders', returns:'Return Requests', wallet:'Earnings & Wallet', deals:'Deals & Offers', profile:'Profile & Address', policies:'Terms & Policies', notifications:'Notifications' };

const SellerPortal = () => {
  const [authed,   setAuthed]   = useState(() => !!localStorage.getItem('seller_token'));
  const [seller,   setSeller]   = useState(() => { try { return JSON.parse(localStorage.getItem('seller_user')||'null'); } catch { return null; } });
  const [tab,      setTab]      = useState('dashboard');
  const [balance,  setBalance]  = useState(null);
  const [unread,   setUnread]   = useState(0);

  // Listen for quick-action nav events from dashboard
  useEffect(() => {
    const handler = (e) => setTab(e.detail);
    document.addEventListener('sp-nav', handler);
    return () => document.removeEventListener('sp-nav', handler);
  }, []);

  // Load wallet balance for topbar
  useEffect(() => {
    if (!authed) return;
    walletAPI.balance().then(r => setBalance(r.data?.available)).catch(() => setBalance(8400));
  }, [authed]);

  const handleLogout = () => {
    clearAuth(); setSeller(null); setAuthed(false);
  };

  if (!authed) {
    return <SellerAuth onAuthSuccess={(s) => { setSeller(s); setAuthed(true); }} />;
  }

  const initials = seller ? `${seller.firstName?.[0]||''}${seller.lastName?.[0]||''}`.toUpperCase() || 'S' : 'S';

  return (
    <div className="sp-root">

      {/* ── SIDEBAR ── */}
      <aside className="sp-sidebar">
        {/* Logo */}
        <div className="sp-sidebar-logo">
          <div className="sp-logo-hex">A</div>
          <div>
            <span className="sp-logo-main">ATR SELLER HUB</span>
            <span className="sp-logo-sub">FARMER MARKETPLACE</span>
          </div>
        </div>

        {/* Seller chip */}
        <div className="sp-seller-card">
          <div className="sp-seller-avatar">{initials}</div>
          <div>
            <div className="sp-seller-name">{seller?.firstName} {seller?.lastName}</div>
            <div className="sp-seller-status">● Verified Seller</div>
          </div>
        </div>

        {/* Nav */}
        <nav className="sp-nav">
          {NAV.map((group, gi) => (
            <div key={gi} style={{marginBottom:'0.75rem'}}>
              <span className="sp-nav-group-title">{group.group.toUpperCase()}</span>
              {group.items.map(item => (
                <button
                  key={item.id}
                  className={`sp-nav-item ${tab === item.id ? 'active' : ''}`}
                  onClick={() => setTab(item.id)}
                >
                  <span className="sp-nav-icon">{item.icon}</span>
                  <span>{item.label}</span>
                  {item.id === 'notifications' && unread > 0 && (
                    <span className="sp-nav-badge alert">{unread}</span>
                  )}
                </button>
              ))}
            </div>
          ))}
        </nav>

        {/* Logout */}
        <button className="sp-logout-btn" onClick={handleLogout}>
          <span style={{fontSize:14}}>✕</span>
          <span>Logout</span>
        </button>
      </aside>

      {/* ── MAIN ── */}
      <main className="sp-main">

        {/* Topbar */}
        <header className="sp-topbar">
          <div className="sp-topbar-title">{PAGE_TITLES[tab]}</div>
          <div className="sp-topbar-right">
            <div className="sp-topbar-stat">
              <span className="sp-topbar-stat-label">Wallet</span>
              <span className="sp-topbar-stat-val">₹{balance !== null ? Number(balance).toLocaleString('en-IN') : '—'}</span>
            </div>
            <button className="sp-withdraw-btn" onClick={() => setTab('wallet')}>Withdraw →</button>
          </div>
        </header>

        {/* Page Content */}
        <div className="sp-content">
          {tab === 'dashboard'    && <SellerDashboard seller={seller} />}
          {tab === 'add-product'  && <AddProducts />}
          {tab === 'pricing'      && <ManagePricing />}
          {tab === 'orders'       && <SellerOrders />}
          {tab === 'returns'      && <SellerReturns />}
          {tab === 'wallet'       && <SellerWallet />}
          {tab === 'deals'        && <SellerDeals />}
          {tab === 'profile'      && <SellerProfile />}
          {tab === 'policies'     && <SellerPolicies />}
          {tab === 'notifications'&& <SellerNotifications />}
        </div>
      </main>
    </div>
  );
};

export default SellerPortal;